import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DateInput from './dateInput/dateInputView';

const Wrapper = styled.div`
  width: 100%;

  && {
    .DayPickerInput {
      width: 100%;

      & > div {
        width: 100%;
      }

      input {
        border: 1px solid #cac8c8;
        height: ${({ size }) => (size === 'regular' ? '45px' : '35px')};
        width: 100%;
        box-sizing: border-box;
        font-weight: normal;
        font-size: 16px;
        color: #383C42;
        z-index: unset;
      }
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FormikDateInput = ({ field, form, size, ...props }) => (
  <Wrapper size={size}>
    <DateInput {...field} {...props} hasMask />
  </Wrapper>
);

FormikDateInput.defaultProps = {
  size: 'regular',
};

FormikDateInput.propTypes = {
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
  size: PropTypes.oneOf(['small', 'regular']),
};

export default FormikDateInput;
